"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BrixelIcon = _interopRequireDefault(require("./BrixelIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BrixelButtonSecondary = props => {
  const {
    bgTransparent = false,
    className = null,
    disabled = false,
    fullWidth = false,
    isLoading = null,
    isSaved = false,
    label,
    labelClass = '',
    leftIcon = null,
    onClick = null,
    onMouseEnter = null,
    onMouseLeave = null,
    onShowError = null,
    rightIcon = null,
    rounded = false,
    small = false,
    large = false,
    theme = 'primary',
    themeSat = theme === 'text' ? 800 : 400,
    transHover = '',
    transHoverSat = '',
    type = 'button'
  } = props;
  // CLASS LISTS
  const themeColor = theme ? `${theme.charAt(0).toUpperCase()}${theme.slice(1)}` : '';
  const themeSatClass = themeSat > 50 && themeColor.toLowerCase() !== 'white' ? themeSat : '';
  const themeClass = `${themeColor}${themeSatClass}`;
  const alignTxt = !leftIcon && !rightIcon ? 'ta-c' : '';
  const bgClass = bgTransparent ? 'bgTransparent' : 'bgWhite';
  const transHoverClass = transHover ? `${transHover.charAt(0).toUpperCase()}${transHover.slice(1)}${transHoverSat || '400'}` : '';
  const isRound = rounded ? 'rounded' : '';
  const isFullWidth = fullWidth ? 'fullWidth' : '';
  const loadingClass = isLoading || isSaved ? 'loading' : '';
  const hasIcon = leftIcon || rightIcon ? 'withIcon' : '';
  let iconPosition = '';
  if (leftIcon) iconPosition = 'iconOnLeft';
  if (rightIcon) iconPosition = 'iconOnRight';
  const isSmall = small ? 'small' : '';
  const isLarge = large ? 'large' : '';
  const onClickBtn = e => {
    e.preventDefault();
    if (onClick && !disabled && !isLoading) onClick(e);else if (onShowError) onShowError(e);
  };
  return /*#__PURE__*/_react.default.createElement("button", {
    onClick: e => onClickBtn(e),
    onMouseEnter: e => onMouseEnter ? onMouseEnter(e) : '',
    onMouseLeave: e => onMouseLeave ? onMouseLeave(e) : '',
    className: `secondaryBtn ${className} brd${themeClass} txt${themeClass} icn${themeClass} transHover${transHoverClass} ${bgClass} ${isRound} ${isSmall} ${isLarge} ${isFullWidth} ${alignTxt} ${loadingClass} ${hasIcon} ${iconPosition} ${disabled ? 'disabled' : ''}`,
    "aria-label": label,
    type: type
  }, leftIcon && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    icon: leftIcon,
    className: "leftIcon"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: `${labelClass} btnLabel`,
    dangerouslySetInnerHTML: {
      __html: label
    }
  }), rightIcon && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    icon: rightIcon,
    className: "rightIcon"
  })), isLoading !== null && (/*#__PURE__*/_react.default.createElement("div", {
    className: "btnLoader"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "lds-ring"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${themeClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${themeClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${themeClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${themeClass}`
  })))), isSaved && (/*#__PURE__*/_react.default.createElement("div", {
    className: "savedIcon"
  }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    color: theme,
    icon: "check"
  }))));
};
var _default = exports.default = BrixelButtonSecondary;